import useSEO from "@/hooks/useSEO";
import LegalLayout from "./LegalLayout";
import { COMPANY } from "@/config/site";

export default function Confidentialite() {
  useSEO({
    title: "Politique de confidentialité (RGPD)",
    description:
      "Politique de confidentialité et de protection des données personnelles de PENOW — collecte, finalités, durée de conservation, droits RGPD, cookies. Conforme au Règlement Général sur la Protection des Données.",
    path: "/confidentialite",
  });

  return (
    <LegalLayout
      title="Confidentialité & RGPD"
      subtitle="Nous nous engageons à protéger vos données personnelles conformément au Règlement Général sur la Protection des Données (Règlement UE 2016/679, dit « RGPD ») et à la loi Informatique et Libertés du 6 janvier 1978 modifiée."
      updatedAt="Décembre 2025"
    >
      <div className="callout" style={{ background: "#FFF5F0", borderLeftColor: "#C05C3D" }}>
        <strong>PENOW — Apporteur d'affaires</strong>
        <br />
        PENOW est une plateforme de mise en relation. Nous n'exécutons aucun
        travaux. Vos données sont collectées puis transmises à un professionnel
        partenaire pour lui permettre de vous adresser un devis. Ce
        professionnel devient alors responsable du traitement des données pour
        la partie exécution des travaux et souscrit ses propres engagements
        RGPD.
      </div>

      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement des données personnelles collectées sur le
        site penow.fr est :
      </p>
      <ul>
        <li><strong>{COMPANY.name}</strong></li>
        <li>{COMPANY.address}</li>
        <li>Téléphone : {COMPANY.phone}</li>
        <li>E-mail : <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
      </ul>

      <h2>2. Données que nous collectons</h2>
      <h3>Formulaire de contact / demande de devis</h3>
      <p>Lorsque vous remplissez notre formulaire de contact, nous collectons :</p>
      <ul>
        <li>Nom et prénom</li>
        <li>Numéro de téléphone</li>
        <li>Adresse e-mail</li>
        <li>Type de travaux envisagés</li>
        <li>Description libre de votre projet</li>
        <li>Photo(s) du chantier — <em>si vous choisissez d'en joindre</em></li>
      </ul>

      <h3>Données techniques (visite du site)</h3>
      <p>
        Lors de votre navigation, des données techniques peuvent être collectées
        de manière automatique : adresse IP tronquée, type de navigateur,
        pages visitées, durée de visite. Ces données sont anonymisées et
        agrégées à des fins statistiques.
      </p>

      <h2>3. Finalités du traitement</h2>
      <p>Vos données sont utilisées uniquement pour :</p>
      <ul>
        <li>Répondre à votre demande de contact ou de devis</li>
        <li>Réaliser et suivre les prestations que vous nous confiez</li>
        <li>Vous adresser des documents contractuels (devis, factures) si nécessaire</li>
        <li>Améliorer le fonctionnement et la sécurité du site (statistiques anonymes)</li>
      </ul>
      <p>
        <strong>Nous ne pratiquons aucune prospection commerciale automatisée,
        aucun profilage, et ne revendons jamais vos données à des tiers.</strong>
      </p>

      <h2>4. Base légale du traitement</h2>
      <ul>
        <li><strong>Consentement</strong> (art. 6.1.a RGPD) — pour l'envoi du formulaire de contact et le dépôt de cookies non essentiels.</li>
        <li><strong>Exécution d'un contrat ou mesures pré-contractuelles</strong> (art. 6.1.b RGPD) — pour la gestion des devis et des chantiers.</li>
        <li><strong>Intérêt légitime</strong> (art. 6.1.f RGPD) — pour la sécurité et l'amélioration du site.</li>
      </ul>

      <h2>5. Destinataires des données</h2>
      <p>
        Vos données sont destinées à l'équipe {COMPANY.name} pour analyser
        votre demande, puis <strong>transmises au professionnel partenaire</strong>
        {" "}retenu pour vous adresser un devis. Elles peuvent également être
        partagées avec les prestataires techniques suivants, strictement
        nécessaires au fonctionnement du service :
      </p>
      <ul>
        <li><strong>Resend</strong> (envoi transactionnel d'e-mails) — <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">politique de confidentialité</a></li>
        <li><strong>MongoDB Atlas</strong> (stockage sécurisé des demandes, hébergé dans l'Union européenne) — <a href="https://www.mongodb.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">politique de confidentialité</a></li>
        <li><strong>PostHog</strong> (statistiques d'audience anonymisées) — <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer">politique de confidentialité</a></li>
      </ul>
      <p>
        Aucune donnée n'est transférée hors de l'Union européenne sans garanties
        appropriées (clauses contractuelles types de la Commission européenne).
      </p>

      <h2>6. Durée de conservation</h2>
      <ul>
        <li><strong>Demandes de contact non abouties</strong> : 3 ans à compter du dernier contact.</li>
        <li><strong>Dossiers clients (devis signés, factures)</strong> : 10 ans à compter de la fin de la prestation (obligation comptable et fiscale).</li>
        <li><strong>Statistiques de visite</strong> : 13 mois maximum.</li>
      </ul>

      <h2>7. Vos droits</h2>
      <p>Conformément au RGPD, vous disposez à tout moment des droits suivants sur vos données :</p>
      <ul>
        <li><strong>Droit d'accès</strong> — obtenir la confirmation que des données vous concernant sont traitées, et en recevoir copie</li>
        <li><strong>Droit de rectification</strong> — corriger des données inexactes ou incomplètes</li>
        <li><strong>Droit d'effacement</strong> (« droit à l'oubli ») — demander la suppression de vos données</li>
        <li><strong>Droit à la limitation</strong> du traitement</li>
        <li><strong>Droit d'opposition</strong> au traitement</li>
        <li><strong>Droit à la portabilité</strong> — recevoir vos données dans un format structuré</li>
        <li><strong>Droit de retirer votre consentement</strong> à tout moment</li>
        <li><strong>Droit de définir des directives</strong> sur le sort de vos données après votre décès</li>
      </ul>

      <div className="callout">
        Pour exercer vos droits, contactez-nous à{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>. Nous vous
        répondrons dans un délai maximum d'un mois. Une pièce d'identité peut
        vous être demandée pour vérifier votre identité.
      </div>

      <h2>8. Réclamation auprès de la CNIL</h2>
      <p>
        Si vous estimez, après nous avoir contactés, que vos droits ne sont pas
        respectés, vous pouvez adresser une réclamation à la Commission
        Nationale de l'Informatique et des Libertés (CNIL) :
      </p>
      <ul>
        <li>3 place de Fontenoy, TSA 80715, 75334 PARIS CEDEX 07</li>
        <li>Site : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a></li>
      </ul>

      <h2>9. Cookies et traceurs</h2>
      <p>
        Notre site utilise des cookies afin d'améliorer votre expérience de
        navigation et de mesurer son audience. Vous pouvez à tout moment
        modifier vos préférences depuis le bandeau qui s'affiche lors de votre
        première visite.
      </p>
      <h3>Types de cookies utilisés</h3>
      <ul>
        <li><strong>Cookies strictement nécessaires</strong> — indispensables au fonctionnement du site (session, préférences). Exemptés de consentement.</li>
        <li><strong>Cookies de mesure d'audience</strong> — PostHog, en mode anonymisé. Soumis à votre consentement.</li>
      </ul>
      <p>
        Aucun cookie publicitaire ou de suivi comportemental n'est déposé sur
        votre appareil.
      </p>

      <h2>10. Sécurité</h2>
      <p>
        Nous mettons en œuvre des mesures techniques et organisationnelles
        appropriées pour protéger vos données contre la destruction, la perte,
        l'altération, la divulgation ou l'accès non autorisé : chiffrement des
        échanges (HTTPS/TLS), stockage sécurisé, accès restreint aux personnes
        habilitées.
      </p>

      <h2>11. Modification de la politique</h2>
      <p>
        La présente politique peut être modifiée à tout moment pour tenir
        compte des évolutions législatives, réglementaires ou techniques. La
        version en vigueur est celle publiée sur cette page.
      </p>
    </LegalLayout>
  );
}
